import { PaymentsApiService } from '@app/subscription/services';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { catchError, EMPTY, filter, map, of, switchMap } from 'rxjs';

import { PLAccountsSuccess } from '@app/common/store';
import { Injectable } from '@angular/core';
import { FeatureFlagService } from '@app/common/services/feature-flag.service';
import { FeatureFlags } from '@app/common/constant';
import * as actions from '../products/products.actions';

@Injectable()
export class LoadProductsEffects {
  loadProducts$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PLAccountsSuccess),
      filter(({ account }) => account?.type === 'individual'),
      switchMap(() =>
        this.featureFlagService
          .isFeatureEnabled(FeatureFlags.SUBSCRIPTION_MANAGEMENT)
          .pipe(
            switchMap((isSubscriptionEnabled) => {
              if (!isSubscriptionEnabled) {
                return EMPTY;
              }

              return this.paymentsApiService.getProducts().pipe(
                map((products) => actions.loadProductsSuccess({ products })),
                catchError((error) => of(actions.loadProductsError({ error })))
              );
            })
          )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private paymentsApiService: PaymentsApiService,
    private featureFlagService: FeatureFlagService
  ) {}
}
